<template>
  <a
    :href="model.url"
    :target="model.openInNewWindow ? '_blank' : '_self'"
    class="c-main-menu__featured-item"
    @click="trackFeaturedItemClick(model.heading)"
  >
    <picture
      v-if="model.imageUrl"
      class="block relative h-0 pb-9/16 mb-3"
    >
      <img
        :src="model.imageUrl"
        class="absolute top-0 left-0 w-full h-full object-cover rounded"
        width="254"
        height="144"
        alt="image"
        loading="lazy"
      >
    </picture>
    <span
      v-if="model.subHeading"
      class="block text-2xs"
      v-text="model.subHeading"
    />
    <strong
      v-if="model.heading"
      v-text="model.heading"
    />
    <p
      v-if="model.text"
      class="text-sm leading-6 mt-4 mb-0 font-light"
      v-text="model.text"
    />
    <div
      v-if="model.linkText"
      class="text-sm mt-4"
    >
      <span class="action">
        <span>{{ model.linkText }}</span>
        <span class="icon-arrow-right-new text-3xs ml-2" />
        <span class="icon-arrow-left mr-2" />
      </span>
    </div>
  </a>
</template>
<script>
import tracking from '@/helpers/tracking'

export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  methods: {
    trackFeaturedItemClick(title) {
      tracking.mainMenuDropdownLinkClick(title, 'featured')
    }
  }
}
</script>
